import Icon from "@mdi/react";
import { mdiInstagram, mdiFacebook, mdiEmail, mdiMapMarker } from "@mdi/js";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-white via-orange-50/20 to-orange-50 text-gray-800 flex flex-col">
      {/* 🔥 MAIN */}
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 py-8 md:py-10 grid gap-6 md:grid-cols-3 text-center md:text-left">
        {/* 🔶 LOGO / ABOUT */}
        <div>
          <h2 className="text-xl sm:text-2xl font-bold mb-2 text-orange-500">
            SGYA
          </h2>

          <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
            സെന്റ് ജോർജ്ജ് യൂത്ത് അസോസിയേഷൻ ചേലക്കര, യുവാക്കളുടെ ആത്മീയവും
            സാമൂഹികവുമായ വളർച്ചയ്ക്കായി പ്രവർത്തിക്കുന്ന സംഘടനയാണ്.
          </p>

          {/* 🔥 SOCIAL */}
          <div className="flex justify-center md:justify-start gap-3 mt-4">
            <a
              href="https://www.instagram.com/sgya_chelakkara"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-orange-100 p-2 rounded-full hover:bg-orange-500 hover:text-white transition"
            >
              <Icon path={mdiInstagram} size={0.9} />
            </a>

            <a
              href="https://www.facebook.com/share/18HNEBX4cz/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-orange-100 p-2 rounded-full hover:bg-orange-500 hover:text-white transition"
            >
              <Icon path={mdiFacebook} size={0.9} />
            </a>
          </div>
        </div>

        {/* 🔶 QUICK LINKS */}
        <div>
          <h3 className="font-semibold text-base sm:text-lg mb-2 text-orange-500">
            Quick Links
          </h3>

          <ul className="space-y-1 text-sm sm:text-base text-gray-600">
            <li>
              <a href="/" className="hover:text-orange-500">
                Home
              </a>
            </li>
            <li>
              <a href="/activities" className="hover:text-orange-500">
                Activities
              </a>
            </li>
            <li>
              <a href="/gallery" className="hover:text-orange-500">
                Gallery
              </a>
            </li>
            <li>
              <a href="/news" className="hover:text-orange-500">
                News
              </a>
            </li>
          </ul>
        </div>

        {/* 🔶 CONTACT */}
        <div>
          <h3 className="font-semibold text-base sm:text-lg mb-2 text-orange-500">
            Contact
          </h3>

          {/* 📍 Location */}
          <a
            href="https://www.google.com/maps/place/St+George+Jacobite+Syrian+Church+Chelakkara"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center md:justify-start gap-2 text-sm sm:text-base text-orange-500 hover:text-orange-600 mb-2 transition"
          >
            <Icon path={mdiMapMarker} size={0.8} />
            <span>St. George Youth Association, Chelakkara</span>
          </a>

          {/* 🗺️ Map */}
          <div className="w-full h-28 sm:h-32 md:h-36 rounded-lg overflow-hidden shadow">
            <iframe
              title="Location Map"
              src="https://www.google.com/maps?q=10.6952628,76.3323996&z=17&output=embed"
              className="w-full h-full border-0"
              loading="lazy"
            ></iframe>
          </div>

          {/* 👉 BUTTON */}
          <a
            href="https://www.google.com/maps/dir//St+George+Jacobite+Syrian+Church+Chelakkara"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 inline-block text-sm text-orange-500 hover:underline"
          >
            Get Directions →
          </a>

          {/* 📧 Email */}
          <a
            href="mailto:sgya.jsoya.chelakkara@gmail.com"
            className="flex items-center justify-center md:justify-start gap-2 text-sm sm:text-base text-gray-600 hover:text-orange-500 mt-3"
          >
            <Icon path={mdiEmail} size={0.8} />
            <span className="break-all">sgya.jsoya.chelakkara@gmail.com</span>
          </a>
        </div>
      </div>

      {/* 🔥 BOTTOM */}
      <div className="border-t border-orange-100 py-4 text-center text-xs sm:text-sm text-gray-500">
        <p>© 2026 SGYA. All rights reserved</p>
        <p className="mt-1">
          Designed & Developed by{" "}
          <span className="text-orange-500 font-semibold">
            Cloud3 Innovative Solutions
          </span>
        </p>
      </div>
    </footer>
  );
}
